import React, { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form as AntdForm } from 'antd';

import { AppBarCMS } from '../../../../../basic/index.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import IngProjectsActiveStudentsEditForm from './IngProjectsActiveStudentsEditForm.jsx';
import { useGetActiveStudentQuery, useGetIngProjectsQuery, useUpdateActiveStudentAssignmentMutation } from '../../../../../../redux/services/ing_projects.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const IngProjectsActiveStudentsEdit = () => {
  const { studentId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = AntdForm.useForm();

  const { saveSuccess: showSaveSuccess, saveError: showSaveError } = useToastMessages();
  const { data: projectsData, isLoading: isLoadingProjects } = useGetIngProjectsQuery();
  const [updateAssignment, { isLoading: isUpdating }] = useUpdateActiveStudentAssignmentMutation();

  // Fetch active student to get student details
  const { data: activeStudent, isLoading: isLoadingStudents } = useGetActiveStudentQuery(studentId);

  // Find the student being edited
  const student = useMemo(() => {
    return activeStudent;
  }, [activeStudent, studentId]);

  const initials = useMemo(
    () => ({
      new_project_id: null,
      new_study_program: null,
      year: student?.year_of_study ?? null,
    }),
    [student],
  );

  if (isLoadingStudents || !student || isLoadingProjects) {
    return <Spinner />;
  }

  const handleSubmit = async (values) => {
    try {
      await updateAssignment({
        studentId: student.id,
        body: {
          ip_project_id: values.new_project_id,
          study_program_id: values.new_study_program,
          year: values.year,
        },
      }).unwrap();

      showSaveSuccess(t('Priradenie študenta bolo úspešne aktualizované'));
      navigate(routes.cmsIngPorjectsActiveStudents);
    } catch (error) {
      console.error('Error updating student assignment:', error);
      showSaveError(error?.data?.error || error?.data?.message || t('Chyba pri aktulizácii priradenia študenta'));
    }
  };

  return (
    <>
      <AppBarCMS
        title={t('Zmeniť priradenie študenta na projekt')}
        backUrl={routes.cmsIngPorjectsActiveStudents}
        backUrlTooltip={t('Späť')}
      />
      <div style={{ margin: '10px' }}>
        <IngProjectsActiveStudentsEditForm
          initials={initials}
          form={form}
          onSubmit={handleSubmit}
          student={student}
          projects={projectsData || []}
          isLoading={isUpdating}
        />
      </div>
    </>
  );
};

export default IngProjectsActiveStudentsEdit;
